// generated by genversion
export var version = '4.4.0';
//# sourceMappingURL=version.js.map